// ie 11
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import uploader from 'vue-simple-uploader';
import axios from './utils/axios';
import store from './store';
import API from './config/API';
import * as config from './config/config';
import ZeesuuLogin from '@zeesuu/login';
import ZeesuuService from '@zeesuu/service';
import lazyPlugin from 'vue3-lazyload';
import './assets/style/global.less';
import './assets/style/swiper-bundle.css';
import login from './components/Login/index';
import helper from './components/Helper/index';
import toast from '@/components/UI/toast/index';
import 'element-plus/dist/index.css';
import VueClipboard from 'vue-clipboard2';
import { pv, sendAction } from '@/utils/pv.js';

if (window.location.href.indexOf(`${window.location.origin}/#/`) > -1) {
  window.location.href = window.location.href.replace(`${window.location.origin}/#/`, `${window.location.origin}/`);
}

const app = createApp(App);
app.config.globalProperties.$config = config;
app.config.globalProperties.$store = store;
app.config.globalProperties.$toast = toast;
app.config.globalProperties.$pv = pv;
app.config.globalProperties.$sendAction = sendAction;
// app.config.errorHandler = (err, vm, info) => {
//   console.log('errorHandler=======star');
//   console.error(err);
//   console.log(vm);
//   console.log(info);
//   console.log('errorHandler=======end');
// };

app.use(router);
app.use(ZeesuuService, {
  $http: axios,
  apis: API,
  debug: process.env.NODE_ENV === 'development',
});
app.use(login, { store });
app.use(helper, { store });
app.use(ZeesuuLogin, { store });
app.use(uploader);
app.use(lazyPlugin, {});
// 全局挂载请求头
app.config.globalProperties.JSON_HEADER = {
  headers: {
    'Content-Type': 'application/json',
  },
};
app.use(VueClipboard);

app.mount('#app');

app.config.productionTip = false;
